export const ROUTES = {
  newsOverview: `/nieuws`,
  privacy: `/privacy-policy`,
};
